// import React, { Component } from 'react';


import React, { useEffect, useState } from 'react';
import Header from '../directives/header';
import Footer from '../directives/footer';
import config from '../config/config';
import axios from 'axios';

import { Player, ControlBar, ClosedCaptionButton } from 'video-react';
import 'react-accessible-accordion/dist/fancy-example.css';


import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
// import 'swiper/swiper-bundle.min.css'
// import 'swiper/swiper.min.css'
// // import ReactPlayer from 'react-player'
// import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Autoplay } from "swiper";

// import Swiper core and required modules
// import SwiperCore, {
//   EffectCube, Pagination
// } from 'swiper';
import { NavLink } from 'react-router-dom';





import Web3 from 'web3';
import Swal from 'sweetalert2'
import { Dialog, Classes } from "@blueprintjs/core";
import '@blueprintjs/core/lib/css/blueprint.css';
import BarLoader from 'react-bar-loader'


// install Swiper modules
// SwiperCore.use([EffectCube, Autoplay]);


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";





var settings = {
  // dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};


function Home() {

  const [isConnectMetamask, setisConnectMetamask] = useState(false);
  const [ConnectWalletAddress, setConnectWalletAddress] = useState('');
  const [MintText, setMintText] = useState('Mint');
  const [TotalMined, setTotalMined] = useState(0);
  const [mintLimit, setMintLimit] = useState(888);
  const [purchased_quantity, setpurchased_quantity] = useState(1);
  const [errorAvailable, seterrorAvailable] = useState('');
  const [isDialogOpen, setisDialogOpen] = useState(false);



  useEffect(() => {
    // if (typeof window.ethereum !== 'undefined') {
    //   console.log('MetaMask is installed!');
    // }
    // connectMetaMask()
    setTimeout(() => {
      if (window.ethereum && localStorage.getItem('isLogout') == '') {
        const { ethereum } = window;
        if (ethereum.selectedAddress) {
          var web3 = new Web3(window.ethereum);
          var currentNetwork = web3.currentProvider.chainId;
          // if (currentNetwork != '56' && currentNetwork != '0x61') {
          //     Cookies.set('loginSuccessMetaseer', "");
          //     return;
          // }
          setConnectWalletAddress(ethereum.selectedAddress)
        }
      }
    }, 1000);

    const { ethereum } = window;
    if (ethereum) {

      ethereum.on('accountsChanged', (add) =>
        manageWallet(add)
      );
      ethereum.on('networkChanged', (chainId) =>
        window.location.reload()
      );
    }
  }, [])


  async function manageWallet(address) {
    let cc = await localStorage.getItem("connectWalletAddress").toString();
    let add = await address.toString();

    if (cc.toUpperCase() != add.toUpperCase()) {
      localStorage.setItem("connectWalletAddress", address);
      window.location.reload();
    }
  }


  const minusQuantity = () => {
    var qty = parseInt(purchased_quantity) - parseInt(1)
    if (purchased_quantity > 1) {
      setpurchased_quantity(qty)
      // this.setState({
      //    'purchased_quantity': qty
      // })
    }

    // if (qty > responsedata.available_quantity) {
    //    seterrorAvailable(1)


    // }
    else if (qty === '0' || qty === '') {
      seterrorAvailable(2)
    }
    else {
      seterrorAvailable(0)
    }
  }


  const plusQuantity = () => {
    var qty = parseInt(purchased_quantity) + parseInt(1);
    if (qty > 10) {
      return;
    }
    setpurchased_quantity(qty)


    if (qty === '0' || qty === '') {
      seterrorAvailable('2')
    }
    else {
      seterrorAvailable('0')
    }

  }



  const connectMetaMask = async () => {
    if (window.ethereum) {
      var isMetaMask = await window.ethereum.isMetaMask;
      if (!isMetaMask) {

        Swal.fire({
          text: 'Please install MetaMask to use this App!',
          // icon: 'warning',
          title: "Alert",
          confirmButtonText: 'Okay',
          confirmButtonColor: 'rgb(1 2 2)',
          background: 'rgb(141 96 153)',
          color: '#fff'
        })
        return;
      }

      if (!window.ethereum.providers) {
        var metamaskProvider = await window.ethereum;
      } else {
        var metamaskProvider = await window.ethereum.providers.find((provider) => provider.isMetaMask);
      }
      try {
        const accounts = await metamaskProvider.request({ method: 'eth_requestAccounts' });
        setConnectWalletAddress(accounts[0])
        setisConnectMetamask(true)
        localStorage.setItem('walletType', 'metamask')
        localStorage.setItem('connectWalletAddress', accounts[0]);
        localStorage.setItem('isLogout', "");

        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: '0x1' }],
        });
        window.location.reload();
      } catch (err) {

        Swal.fire({
          text: err.message,
          // icon: 'warning',
          title: "Alert",
          confirmButtonText: 'Okay',
          confirmButtonColor: 'rgb(1 2 2)',
          background: 'rgb(141 96 153)',
          color: '#fff'
        })
      }

    }
    else {
      Swal.fire({
        text: 'Please install MetaMask to use this App!',
        // icon: 'warning',
        title: "Alert",
        confirmButtonText: 'Okay',
        confirmButtonColor: 'rgb(1 2 2)',
        background: 'rgb(141 96 153)',
        color: '#fff'
      })

    }
  }

  const getCurrentProvider = async () => {
    let CurrentProvider = "";
    if (localStorage.getItem("connectWalletAddress") && localStorage.getItem("walletType") == 'metamask') {
      if (!window.ethereum.providers) {
        CurrentProvider = await window.ethereum;
      } else {
        CurrentProvider = await window.ethereum.providers.find((provider) => provider.isMetaMask);
      }
    } else {
      if (!window.ethereum.providers) {
        if (window.ethereum.isCoinbaseWallet == true) {
          CurrentProvider = await window.ethereum;
        }
      } else {
        CurrentProvider = await window.ethereum.providers.find((provider) => provider.isCoinbaseWallet);
      }
    }
    return CurrentProvider;
  }

  const enterNumber = (e) => {
    setpurchased_quantity(e.target.value);
  }
  const mintItem = async (e) => {

    if (MintText === "Processing...") {
      return;
    }

    let nftNumber = parseInt(purchased_quantity);

    if (nftNumber > 10) {
      Swal.fire({
        text: '10 NFTs mint in per transaction',
        // icon: 'warning',
        title: "Alert",
        confirmButtonText: 'Okay',
        confirmButtonColor: 'rgb(1 2 2)',
        background: 'rgb(141 96 153)',
        color: '#fff'
      })
      return;
    }
    // if (parseInt(TotalMined) + nftNumber > parseInt(mintLimit)) {
    //   let mint = parseInt(mintLimit) - parseInt(TotalMined);
    //   Swal.fire({
    //     text: 'Only ' + mint + ' slot left for mint',
    //     // icon: 'warning',
    //     title: "Alert",
    //     confirmButtonText: 'Okay',
    //     confirmButtonColor: 'rgb(1 2 2)',
    //     background: 'rgb(141 96 153)',
    //     color: '#fff'
    //   })
    //   return;
    // }
    if (!localStorage.getItem("connectWalletAddress") && localStorage.getItem('isLogout')) {
      connectMetaMask();
      return;
    }

    const providers = await getCurrentProvider();
    const web3 = new Web3(providers);

    try {
      web3.eth.defaultAccount = localStorage.getItem("connectWalletAddress");

      if (web3.currentProvider.networkVersion != 1 && web3.currentProvider.networkVersion != '0x1') {

        Swal.fire({
          text: 'Please select Rinkeby Ethereum network!',
          // icon: 'warning',
          title: "Alert",
          confirmButtonText: 'Close',
          confirmButtonColor: 'rgb(1 2 2)',
          background: 'rgb(141 96 153)',
          color: '#fff'
        })
        return;
      }
      setMintText("Processing...");
      setisDialogOpen(true);
      const NFT_CONTRACT = await new web3.eth.Contract(config.ABI, config.contractAddress);
      let from_address = await web3.eth.getAccounts();
      from_address = from_address[0];
      // let balance = await web3.eth.getBalance(from_address);

      let chainId = '0x1';


      let getMintFees = await NFT_CONTRACT.methods.getMintFees(nftNumber).call();
      getMintFees = parseInt(getMintFees);

      let myAddress = from_address.toUpperCase();

      let contractOnwer = await NFT_CONTRACT.methods.owner().call();

      let encoded_tx = "";
      if (myAddress == contractOnwer.toUpperCase()) {
        let tx_builder = await NFT_CONTRACT.methods.mintAsOwner(nftNumber);
        encoded_tx = tx_builder.encodeABI();
        getMintFees = 0;
      } else {
        let tx_builder = await NFT_CONTRACT.methods.mint(nftNumber);
        encoded_tx = tx_builder.encodeABI();
      }
      let whitelist = await NFT_CONTRACT.methods.whitelist(from_address).call();


      if (whitelist) {
        getMintFees = 0;
      }

      let gasPrice = await web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice) + 10000000000;

      let gasLimit = await web3.eth.estimateGas({
        gasPrice: web3.utils.toHex(gasPrice),
        to: config.contractAddress,
        from: from_address,
        value: web3.utils.toHex(getMintFees),
        chainId: chainId,
        data: encoded_tx
      });

      const transactionParameters = {
        from: from_address,
        gasPrice: web3.utils.toHex(gasPrice),
        gas: web3.utils.toHex(gasLimit),
        to: config.contractAddress,
        value: web3.utils.toHex(getMintFees),
        chainId: chainId,
        data: encoded_tx
      };

      // const txHash = await web3.eth.sendTransaction(transactionParameters);
      let txHash = await web3.currentProvider.request({
        method: 'eth_sendTransaction',
        params: [transactionParameters],
      });
      // let messageAlert = `<span>Transaction details : <a style="color:blue" href="https://etherscan.io/tx/${txHash.transactionHash}" target="_blank">0x....hash</a> </span>`;
      // messageAlert = ` ${messageAlert} <br/> <a style="color:blue" href="https://testnets.opensea.io/${localStorage.getItem("connectWalletAddress")}" target="_blank">View on Opensea</a> </span>`

      if (txHash) {
        Swal.fire({
          width: 500,
          title: 'Successful!',
          html: 'Congratulation! NFT minted Successfully.',
          // icon: 'warning',
          title: "Alert",
          confirmButtonText: 'Ok, Thanks',
          confirmButtonColor: 'rgb(1 2 2)',
          background: 'rgb(141 96 153)',
          color: '#fff'
        }).then((result) => {
          window.location.reload();
        })
      }
    } catch (err) {
      console.log("err", err)
      setMintText("Mint");
      setisDialogOpen(false);
      if (err.message.toString().split('insufficient funds')[1]) {

        Swal.fire({
          text: 'Transaction reverted : ' + err.message,
          // icon: 'warning',
          title: "Alert",
          confirmButtonText: 'Close',
          confirmButtonColor: 'rgb(1 2 2)',
          background: 'rgb(141 96 153)',
          color: '#fff'
        })
      } else {
        if (err.toString().split('execution reverted:')[1]) {
          Swal.fire({
            text: 'Transaction reverted : ' + (err.toString().split('execution reverted:')[1]).toString().split('{')[0],
            // icon: 'warning',
            title: "Alert",
            confirmButtonText: 'Close',
            confirmButtonColor: 'rgb(1 2 2)',
            background: 'rgb(141 96 153)',
            color: '#fff'
          })
        } else {
          if (err.message.toString().search(/supplied gas/) > -1 || err.message.toString().search(/exceeds allowance/) > -1) {
            Swal.fire({
              text: "Transaction reverted : insufficient funds for transaction fee",
              // icon: 'warning',
              title: "Alert",
              confirmButtonText: 'Close',
              confirmButtonColor: 'rgb(1 2 2)',
              background: 'rgb(141 96 153)',
              color: '#fff'
            })
          } else {
            Swal.fire({
              text: err.message,
              // icon: 'warning',
              title: "Alert",
              confirmButtonText: 'Close',
              confirmButtonColor: 'rgb(1 2 2)',
              background: 'rgb(141 96 153)',
              color: '#fff'
            })
          }
        }
      }
    }

  }

  const connectWallet = async () => {


    try {

      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: '0x1' }],
      });
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: '0x1',
                chainName: 'Ethereum Mainnet',
                rpcUrls: ['https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161'],
              },
            ],
          });
        } catch (addError) {
          console.log("addError", addError)
          // handle "add" error
        }
      }
      // handle other "switch" errors
    }
  }


  return (

    <>

      <Header />
      <header id="header" className="header   text-light">

        <div className="media-container parallax-window" data-parallax="scroll" data-image-src />
        <Dialog
          title="Processing..."
          // icon="warning-sign"
          style={{
            color: 'red',
          }}
          isOpen={isDialogOpen}
          isCloseButtonShown={false}
        >
          <div className="text-center">
            <BarLoader color="#e84747" height="2" />
            <br />
            <h4 style={{ color: '#000' }}>Transaction under process...</h4>
            <p style={{ color: 'red' }}>
              Please do not refresh page or close tab.
            </p>
            <div>
            </div>
          </div>
        </Dialog>

        {/* <div className="overlay d-flex align-items-center"> */}
        <div className='banner-slider'>
          <div className="container  mt-4">
            <div className="row align-items-center justify-content-center">
              <div className='col-lg-3 text-center'>

                {/* <lottie-player src="https://assets9.lottiefiles.com/packages/lf20_qc3pdcqf.json" background="transparent" speed={1} style={{width: '100%', height: '100%'}} loop autoPlay /> */}
                {/* <lottie-player src="https://assets5.lottiefiles.com/temp/lf20_DGLtjO.json" background="transparent" speed={1} style={{ width: '100%', height: '100%' }} loop autoPlay /> */}
              </div>
              <div className="col-lg-6">
                <div className='banner text-center'>
                  <h1 className=''>10,000</h1>
                  <h2 className=''>Booty Coin</h2>

                  {/* <input type="number" onChange={enterNumber} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder='1' /> */}
                  <div className="number">
                    <span className="minus" onClick={minusQuantity}>-</span>
                    <input id='count_input' readOnly type="text" value={purchased_quantity} />
                    <span className="plus" onClick={plusQuantity}>+</span>
                  </div>

                  <button className='btn btn-primary mb-2 btn-mint' onClick={mintItem}>
                    {MintText}
                  </button><br />
                  <div className='smoke_gif'>
                    <img src='assets/img/420 Smoke_1.gif' />
                  </div>
                  {/* <button className='btn btn-primary mb-2 btn-mint' >
                      10
                    </button> */}

                  {/* <p>
                   Booty Coin Mint is a collection of 10,000 NFT's stored as ERC-721 tokens on the Ethereum blockchain and hosted on IPFS.
                  </p> */}
                  {/* <a href="#" className='btn btn-primary mb-2 btn-discord' id="discord_section_first">DISCORD<img src="assets/img/Discord-Logo.png" width="25px" style={{ "filter": "brightness(0) invert(1)", "object-fit": "contain", marginTop: '-3px' }} /></a> */}
                  {/* <button className='btn btn-primary mb-2 btn-mint'>DISCORD<img src="assets/img/Discord-Logo.png" width="25px" style={{"filter":"brightness(0) invert(1)","object-fit":"contain","margin-top" : "-3px"}} /></button> */}
                  {/* <h3>Own a Real Like Booty Coin</h3> */}
                  {/* <p>
                    EachBooty Coin Mint is a unique programmatically generated with insane traits, including skin, eyes, expressions, clothing and so much more.

                  </p> */}

                </div>




              </div>
              {/* <div className='col-lg-6 text-center'>
                <img src='assets/img/509.png' width="100%" className='jack_monkey' />
              </div> */}
              <div className='col-lg-3'>
                {/* <lottie-player src="https://assets9.lottiefiles.com/packages/lf20_qc3pdcqf.json" background="transparent" speed={1} style={{width: '100%', height: '100%'}} loop autoPlay /> */}
                {/* <lottie-player src="https://assets5.lottiefiles.com/temp/lf20_DGLtjO.json" background="transparent" speed={1} style={{ width: '100%', height: '100%' }} loop autoPlay /> */}



              </div>


            </div>

          </div>

        </div>

        {/* </div> */}
        {/* <div className="fadeIn ad-800ms">
          <div className="down-arrow floating-arrow absolute-center-X">
            <span className="fas fa-chevron-down" />
          </div>
        </div> */}
      </header>
      {/*       
      <div className='container-fluid pl-0 pr-0'>
        <div className='marquee-text'>
          <marquee style={{ marginTop: '8px', fontSize: '16px' }} scrollamount="5">
            
         Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD | Presale Date TBD | Mint Date TBD | Price TBD |
            
          </marquee>

        </div>

      </div> */}
      <main className="main-content">

        {/* Start Content Area */}
        <section id="Meet_Our_Bac" className="content-section position-relative text-light  parallax-window" data-parallax="scroll" data-image-src="#" >
          <div className="container-fluid position-relative">
            {/* <div className="row"> */}
            {/* <div className="col-sm-12 col-md-12 col-lg-12 mx-auto text-center pl-0 pr-0">
                
                <h2 className="ls-1 mb-5 ">MEET OUR BOOTY COIN</h2>

               
              </div> */}
            {/* <div className="col-sm-6 col-md-6 col-lg-5 mx-auto mb-7 md-lg-0">
                <div className="common-container">
                  <div className="row">
                    <div className="pb-2 pr-2 col-6">
                      {content1.data?.response[0].image1 === null || content1.data?.response[0].image1 === '' || content1.data?.response[0].image1 === undefined
                        ?
                        <img src='assets/img/content/mon_1.jpg' className="img-fluid" />
                        :
                        <img src={`${config.imageUrl}${content1.data?.response[0].image1}`} alt="image" className="img-fluid" />}

                    </div>
                    <div className="pb-2 pl-2 col-6">
                      {content1.data?.response[0].image2 === null || content1.data?.response[0].image2 === '' || content1.data?.response[0].image2 === undefined
                        ?
                        <img src='assets/img/content/mon_4.jpg' className="img-fluid" />
                        :
                        <img src={`${config.imageUrl}${content1.data?.response[0].image2}`} alt="image" className="img-fluid" />}
                    </div>
                  </div>
                  <div className="row">
                    <div className="pt-2 pr-2 col-6">
                      {content1.data?.response[0].image3 === null || content1.data?.response[0].image3 === '' || content1.data?.response[0].image3 === undefined
                        ?
                        <img src='assets/img/content/mon_9.jpg' className="img-fluid" />
                        :
                        <img src={`${config.imageUrl}${content1.data?.response[0].image3}`} alt="image" className="img-fluid" />}
                    </div>
                    <div className="pt-2 pl-2 col-6">
                      {content1.data?.response[0].image4 === null || content1.data?.response[0].image4 === '' || content1.data?.response[0].image4 === undefined
                        ?
                        <img src='assets/img/content/mon_14.jpg' className="img-fluid" />
                        :
                        <img src={`${config.imageUrl}${content1.data?.response[0].image4}`} alt="image" className="img-fluid" />}
                    </div>
                  </div>
                </div>
              </div> */}

            {/* </div> */}
          </div>
          <div className='container-fluid'>
            <div className='meet_our'>
              <Slider {...settings}>
                <div>
                  <img src='assets/img/5 Silver.png' width="100%" />
                </div>
                <div>
                  <img src='assets/img/30 Ukraine.png' width="100%" />
                </div>
                <div>
                  <img src='assets/img/Bone75X.png' width="100%" />
                </div>
                <div>
                  <img src='assets/img/Bronze10X.png' width="100%" />
                </div>
                <div>
                  <img src='assets/img/Cooper1X.png' width="100%" />
                </div>
                <div>
                  <img src='assets/img/Ice500x.png' width="100%" />
                </div>
                <div>
                  <img src='assets/img/Marble250X.png' width="100%" />
                </div>
                <div>
                  <img src='assets/img/Onyx50X.png' width="100%" />
                </div>
                <div>
                  <img src='assets/img/5 Silver.png' width="100%" />
                </div>
                <div>
                  <h3><img src='assets/img/wood100x.png' /></h3>
                </div>

              </Slider>
              {/* <Swiper
                slidesPerView={1}
                spaceBetween={10}

                pagination={{
                  clickable: true,
                }}
              
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                  },
                  1024: {
                    slidesPerView: 6,
                    spaceBetween: 50,
                  },
                }}

                modules={[Autoplay, Pagination]}
                className="mySwiper"
              >
                <SwiperSlide><img src='assets/img/5 Silver.png' /></SwiperSlide>
              
                <SwiperSlide><img src='assets/img/30 Ukraine.png' /></SwiperSlide>
                <SwiperSlide><img src='assets/img/Bone75X.png' /></SwiperSlide>
                <SwiperSlide><img src='assets/img/Bronze10X.png' /></SwiperSlide>
                <SwiperSlide><img src='assets/img/Cooper1X.png' /></SwiperSlide>
                <SwiperSlide><img src='assets/img/Ice500x.png' /></SwiperSlide>
                <SwiperSlide><img src='assets/img/Marble250X.png' /></SwiperSlide>
                <SwiperSlide><img src='assets/img/Onyx50X.png' /></SwiperSlide>
                <SwiperSlide><img src='assets/img/5 Silver.png' /></SwiperSlide>
                <SwiperSlide><img src='assets/img/wood100x.png' /></SwiperSlide>

               
              </Swiper> */}

              {/* <ul>
                <li><img src='assets/img/10.webp' /></li>
                <li><img src='assets/img/flip2.jpg' /></li>
                <li><img src='assets/img/nft2.jpg' /></li>
                <li><img src='assets/img/11.webp' /></li>
                <li><img src='assets/img/12.webp' /></li>
                <li><img src='assets/img/13.webp' /></li>
                <li><img src='assets/img/14.webp' /></li>
                <li><img src='assets/img/15.webp' /></li>
                <li><img src='assets/img/16.webp' /></li>
                <li><img src='assets/img/17.webp' /></li>
                <li><img src='assets/img/18.webp' /></li>
                <li><img src='assets/img/19.webp' /></li>
                <li><img src='assets/img/20.webp' /></li>
                <li><img src='assets/img/21.webp' /></li>
                <li><img src='assets/img/22.webp' /></li>
                <li><img src='assets/img/23.webp' /></li>
                <li><img src='assets/img/24.webp' /></li>
                <li><img src='assets/img/25.webp' /></li>
                <li><img src='assets/img/26.webp' /></li>
                <li><img src='assets/img/27.webp' /></li>
                <li><img src='assets/img/28.webp' /></li>
                <li><img src='assets/img/29.webp' /></li>
                <li><img src='assets/img/30.webp' /></li>
                <li><img src='assets/img/31.webp' /></li>
                <li><img src='assets/img/32.webp' /></li>
                <li><img src='assets/img/11.webp' /></li>
                <li><img src='assets/img/12.webp' /></li>
                <li><img src='assets/img/13.webp' /></li>
                <li><img src='assets/img/14.webp' /></li>
                <li><img src='assets/img/15.webp' /></li>
                <li><img src='assets/img/16.webp' /></li>
                <li><img src='assets/img/17.webp' /></li>
                <li><img src='assets/img/18.webp' /></li>
                <li><img src='assets/img/19.webp' /></li>
                <li><img src='assets/img/20.webp' /></li>
                <li><img src='assets/img/21.webp' /></li>
                <li><img src='assets/img/22.webp' /></li>
                <li><img src='assets/img/23.webp' /></li>
                <li><img src='assets/img/24.webp' /></li>
                <li><img src='assets/img/25.webp' /></li>
                <li><img src='assets/img/26.webp' /></li>
                <li><img src='assets/img/27.webp' /></li>
                <li><img src='assets/img/28.webp' /></li>
                <li><img src='assets/img/29.webp' /></li>
                <li><img src='assets/img/30.webp' /></li>
                <li><img src='assets/img/31.webp' /></li>
                <li><img src='assets/img/32.webp' /></li>
                <li><img src='assets/img/flip2.jpg' /></li>
                




              </ul> */}
              {/* <ul>
                <li><img src='assets/img/10.webp' /></li>
                <li><img src='assets/img/flip2.jpg' /></li>
                <li><img src='assets/img/nft2.jpg' /></li>
                <li><img src='assets/img/11.webp' /></li>
                <li><img src='assets/img/12.webp' /></li>
                <li><img src='assets/img/13.webp' /></li>
                <li><img src='assets/img/17.webp' /></li>
                <li><img src='assets/img/20.webp' /></li>
                <li><img src='assets/img/15.webp' /></li>
                <li><img src='assets/img/17.webp' /></li>
                <li><img src='assets/img/18.webp' /></li>
                <li><img src='assets/img/19.webp' /></li>
                <li><img src='assets/img/11.webp' /></li>
                <li><img src='assets/img/22.webp' /></li>
                <li><img src='assets/img/25.webp' /></li>
                <li><img src='assets/img/23.webp' /></li>
                <li><img src='assets/img/26.webp' /></li>
                <li><img src='assets/img/19.webp' /></li>
                <li><img src='assets/img/12.webp' /></li>
                <li><img src='assets/img/26.webp' /></li>
                <li><img src='assets/img/28.webp' /></li>
                <li><img src='assets/img/29.webp' /></li>
                <li><img src='assets/img/30.webp' /></li>
                <li><img src='assets/img/20.webp' /></li>
                <li><img src='assets/img/32.webp' /></li>
                <li><img src='assets/img/11.webp' /></li>
                <li><img src='assets/img/14.webp' /></li>
                <li><img src='assets/img/20.webp' /></li>
                <li><img src='assets/img/30.webp' /></li>
                <li><img src='assets/img/15.webp' /></li>
                <li><img src='assets/img/16.webp' /></li>
                <li><img src='assets/img/17.webp' /></li>
                <li><img src='assets/img/18.webp' /></li>
                <li><img src='assets/img/19.webp' /></li>
                <li><img src='assets/img/10.webp' /></li>
                <li><img src='assets/img/21.webp' /></li>
                <li><img src='assets/img/12.webp' /></li>
                <li><img src='assets/img/flip2.jpg' /></li>
                <li><img src='assets/img/24.webp' /></li>
                <li><img src='assets/img/25.webp' /></li>
                <li><img src='assets/img/32.webp' /></li>
                <li><img src='assets/img/27.webp' /></li>
                <li><img src='assets/img/28.webp' /></li>
                <li><img src='assets/img/29.webp' /></li>
                <li><img src='assets/img/25.webp' /></li>
                <li><img src='assets/img/31.webp' /></li>
                <li><img src='assets/img/32.webp' /></li>
                <li><img src='assets/img/flip2.jpg' /></li>
                




              </ul> */}
            </div>

          </div>
        </section>

        <section id="roadmap" className="content-section position-relative latest-articles text-light text-center parallax-window">
          <div className="container" >
            <header className=" text-center mb-5">
              <h2 className="roadmap">Roadmap </h2>

              <hr className="w-10 border-success border-top-2 o-90" />
              <button className='btn btn-primary roadmap'>WhitePaper</button>
              <p className="lead-1 text-center">Wealth, fame, power, girls with big breasts and big booties, the Pirate King acquired everything this world has to offer. Just before his death the words he cried out drove the masses to the Opensea..."My Booty? If you want it, you can have it! Find it if you dare! I left everything this world gave me on the Opensea!"</p>
              <p className='lead-1 text-center'>And thus men and women head for the Opensea in pursuit of his booty, and the chance to become the next Pirate King! </p>
              <p className='lead-1 text-center'> Death to the memes! Welcome, to the pirate era!</p>
            </header>
            <div className="row">
              <div className="col-md-12">
                <img src='assets/img/roadmap.png' />
                {/* <div className="main-timeline4">
                  <div className="timeline">
                    <a href="#" className="timeline-content">
                      <span className="year">1.</span>
                      <div className="inner-content">
                        <h3 className="title">Let Us Buy You A Drink</h3>
                        <p className="description"> We will be putting $100,000 into the community wallet directly after mint! The community will vote on how we use this money! We will continue to re-invest into the project as well as add more to the community wallet!</p>
                      </div>
                    </a>
                  </div>
                  <div className="timeline">
                    <a href="#" className="timeline-content">
                      <span className="year">2.</span>
                      <div className="inner-content">
                        <h3 className="title">Construction Zone </h3>
                        <p className="description">We will officially break ground to our first Booty Coin Location! ALL HOLDERS of B.A.C will help us in designing the Bar as well as what is on the menu and the drinks we serve!</p>
                      </div>
                    </a>
                  </div>
                  <div className="timeline">
                    <a href="#" className="timeline-content">
                      <span className="year">3.</span>
                      <div className="inner-content">
                        <h3 className="title">Grand Opening </h3>
                        <p className="description">The WORLDS FIRST Booty Coin officially opens! Every single B.A.C holder is invited! We have tons of things planned for you guys during grand opening! Come have a drink and meet the community! </p>
                      </div>
                    </a>
                  </div>
                  <div className="timeline">
                    <a href="#" className="timeline-content">
                      <span className="year">4.</span>
                      <div className="inner-content">
                        <h3 className="title">Endless Summer</h3>
                        <p className="description"> 50% of monthly profits from Booty Coin will be put in the B.A.C DAO. Holders will receive Happy Hour discounts 365 days out of the year! The community will have the chance to be on the "Wall of Fame" in the Bar! ALL 111 1/1 holders will receive FREE BEER every day for the rest of their life at the Booty Coin!
                        </p>
                      </div>
                    </a>
                  </div>
                  <div className="timeline">
                    <a href="#" className="timeline-content">
                      <span className="year">6.</span>
                      <div className="inner-content">
                        <h3 className="title">The Future</h3>
                        <p className="description">We plan on continuing the legacy of B.A.C and The Booty Coin by establishing new locations in the future. We also plan on having many meet-ups within Florida as well as California and New York! In order to achieve this, we need our community, with you guys anything is possible!</p>
                      </div>
                    </a>
                  </div>
                </div> */}
              </div>
            </div>


          </div>
        </section>


        {/* Start Content Area */}
        <section id="team" className="content-section team-section latest-articles position-relative text-center text-light parallax-window " data-parallax="scroll" data-image-src="#" >
          <div className="container position-relative">
            <header className="section-header">
              <h2 className="text-light ">Our Team</h2>
              <hr className="w-10 border-success border-top-2 o-90" />
            </header>
            <div className="">
              <div className="">

                {/* ********* <3 ********* EIGHT ********* <3 ********* */}
                <div className="row">
                  <div className="col-md-4 col-12 mb-5 ">
                    <a href="#" />
                    <article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5">
                      <a href="#">
                        <div className="position-relative overflow-hidden br-n article-image ar-1_1 w-70 mx-auto border border-secondary mb-3" style={{ "background-image": "url('./assets/img/captain_nobeard.jpeg')", "background-size": "100% 100%" }} />
                      </a>
                      <figure>
                        <a href />
                        <figcaption>
                          <a href="#" />
                          <h5 className="text-light mt-1 mb-0"><a href="#" /><a href="#" className="text-light"> Captain Nobeard</a><p>Founder</p></h5>
                          {/* <div className="social-buttons lead-1">
                            <a className="social-facebook" href="#" target="_blank"><i className="fab fa-facebook" /></a>
                            <a className="social-twitter" href="https://twitter.com/CR_850" target="_blank"><i className="fab fa-twitter" /></a>
                            <a className="social-instagram" href="#" target="_blank"><i className="fab fa-instagram" /></a>
                            <a className="social-dribbble" href="#" target="_blank"><i className="fab fa-linkedin" /></a>
                          </div> */}
                        </figcaption>
                      </figure>
                    </article>
                  </div>
                  <div className="col-md-4 col-12 mb-5 ">
                    <a href="#" />
                    <article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5">
                      <a href="#">
                        <div className="position-relative overflow-hidden br-n article-image ar-1_1 w-70 mx-auto border border-secondary mb-3" style={{ "background-image": "url('./assets/img/admiral_hugh_mac.jpeg')", "background-size": "100% 100%" }} />
                      </a>
                      <figure>
                        <a href />
                        <figcaption>
                          <a href="#" />
                          <h5 className="text-light mt-1 mb-0"><a href="#" /><a href="#" className="text-light"> Admiral Hugh Mac</a><p>Founder</p></h5>
                          {/* <div className="social-buttons lead-1">
                            <a className="social-facebook" href="#" target="_blank"><i className="fab fa-facebook" /></a>
                            <a className="social-twitter" href="#" target="_blank"><i className="fab fa-twitter" /></a><a className="social-instagram" href="https://www.instagram.com/nft_crypto_ceo/" target="_blank"><i className="fab fa-instagram" /></a>
                            <a className="social-dribbble" href="#" target="_blank"><i className="fab fa-linkedin" /></a>
                          </div> */}
                        </figcaption>
                      </figure>
                    </article>
                  </div>
                  <div className="col-md-4 col-12 mb-5">
                    <a href="#" />
                    <article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5">
                      <a href="#">
                        <div className="position-relative overflow-hidden br-n article-image ar-1_1 w-70 mx-auto border border-secondary mb-3" style={{ "background-image": "url('./assets/img/wooden_coin.png')", "background-size": "100% 100%" }} />
                      </a>
                      <figure>
                        <a href />
                        <figcaption>
                          <a href="#" />
                          <h5 className="text-light mt-1 mb-0"><a href="#" /><a href="#" className="text-light"> Dread Pirate Roberts</a><p>Founder</p></h5>
                          <div className="social-buttons lead-1">
                            {/* <a className="social-twitter" href="https://twitter.com/imtempy?s=11" target="_blank"><i className="fab fa-twitter" /></a> */}
                            {/* <a className="social-instagram" href="https://music.amazon.com/artists/B09J17N2M6/redouane-belhadi" target="_blank"><img src="assets/img/apple-music.png" width="20px" style={{ "margin-top": "-6px" }} /></a> */}
                          </div>
                        </figcaption>
                      </figure>
                    </article>
                  </div>
                  <div className="col-md-4 col-12 mb-5 ">
                    <a href="#" />
                    <article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5">
                      <a href="#">
                        <div className="position-relative overflow-hidden br-n article-image ar-1_1 w-70 mx-auto border border-secondary mb-3" style={{ "background-image": "url('./assets/img/commodore_cabeza_grande.jpeg')", "background-size": "100% 100%" }} />
                      </a>
                      <figure>
                        <a href />
                        <figcaption>
                          <a href="#" />
                          <h5 className="text-light mt-1 mb-0"><a href="#" /><a href="#" className="text-light"> Commodore Cebaza Grande</a><p>Founder</p></h5>
                          <div className="social-buttons lead-1">
                            {/* <a className="social-twitter" href="https://twitter.com/yo_aidenn" target="_blank"><i className="fab fa-twitter" /></a> */}
                            {/* <a className="social-twitter" href="https://www.facebook.com/elijah.shelley.1" target="_blank"><i className="fab fa-twitter" /></a> */}
                            {/* <a className="social-instagram" href="https://www.instagram.com/yo.aidenn/?utm_medium=copy_link" target="_blank"><i className="fab fa-instagram" /></a> */}
                            {/* <a className="social-dribbble" href="https://www.linkedin.com/search/results/all/?keywords=elijah%20shelley&origin=RICH_QUERY_TYPEAHEAD_HISTORY&position=0&searchId=af04c786-d68e-4258-9dad-60d6d6811e1c&sid=IXr" target="_blank"><i className="fab fa-linkedin" /></a> */}
                          </div>
                        </figcaption>
                      </figure>
                    </article>
                  </div>
                  <div className="col-md-4 col-12 mb-5">
                    <a href="#" />
                    <article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5">
                      <a href="#">
                        <div className="position-relative overflow-hidden br-n article-image ar-1_1 w-70 mx-auto border border-secondary mb-3" style={{ "background-image": "url('./assets/img/squidlips_mcgee.jpeg')", "background-size": "100% 100%" }} />
                      </a>
                      <figure>
                        <a href />
                        <figcaption>
                          <a href="#" />
                          <h5 className="text-light mt-1 mb-0"><a href="#" /><a href="#" className="text-light"> Squidlips Longhair</a><p>Chief of Marketing</p></h5>
                          {/* <div className="social-buttons lead-1">
                            <a className="social-instagram" href="https://www.instagram.com/redouane_belhadi/" target="_blank"><i className="fab fa-instagram" /></a>
                            <a className="social-instagram" href="https://music.amazon.com/artists/B09J17N2M6/redouane-belhadi" target="_blank"><img src="assets/img/apple-music.png" width="20px" style={{ "margin-top": "-6px" }} /></a>
                          </div> */}
                        </figcaption>
                      </figure>
                    </article>
                  </div>
                  <div className="col-md-4 col-12 mb-5 ">
                    <a href="#" />
                    <article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5">
                      <a href="#">
                        <div className="position-relative overflow-hidden br-n article-image ar-1_1 w-70 mx-auto border border-secondary mb-3" style={{ "background-image": "url('./assets/img/cap_n_tally.jpeg')", "background-size": "100% 100%" }} />
                      </a>
                      <figure>
                        <a href />
                        <figcaption>
                          <a href="#" />
                          <h5 className="text-light mt-1 mb-0"><a href="#" /><a href="#" className="text-light"> Cap'n Tally</a><p>Artist/Ad Manager</p></h5>
                          {/* <div className="social-buttons lead-1">
                            <a className="social-facebook" href="https://www.facebook.com/elijah.shelley.1" target="_blank"><i className="fab fa-facebook" /></a>
                            <a className="social-instagram" href="https://www.instagram.com/shelleyelijah/" target="_blank"><i className="fab fa-instagram" /></a>
                            <a className="social-linkedine" href="https://www.linkedin.com/search/results/all/?keywords=elijah%20shelley&origin=RICH_QUERY_TYPEAHEAD_HISTORY&position=0&searchId=af04c786-d68e-4258-9dad-60d6d6811e1c&sid=IXr" target="_blank"><i className="fab fa-linkedin" /></a>
                          </div> */}
                        </figcaption>
                      </figure>
                    </article>
                  </div>

                </div>
                {/* <ul className="eight">
  <li className="transition">
    <div className="wrapper">
      <span className="transition">
        <h3 className="transition">Corey Robinson <em></em></h3>
        <div className="image-container transition">
          <div className="creation">
            <div className="front">
              <div className="cont"> <i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1641156901302.jpg" alt="image" className="icon-circle transition" /></i> </div>
            </div>
            <div className="back">
              <div className="cont"><i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1641156901302.jpg" alt="image" /></i> </div>
            </div>
          </div>
        </div>
      </span>
      <ul className="social transition">
        <div className="social-buttons lead-1">
          <a className="social-facebook" href="https://www.facebook.com/corey.robinson.1460" target="_blank"><i className="fab fa-facebook" /></a>
        <a className="social-twitter" href="https://twitter.com/CR_850" target="_blank"><i className="fab fa-twitter" /></a>
        <a className="social-instagram" href="https://www.instagram.com/corey.850/" target="_blank"><i className="fab fa-instagram" /></a>
        <a className="social-dribbble" href="https://www.linkedin.com/in/corey-r-7b931bab/" target="_blank"><i className="fab fa-linkedin" /></a></div>
      </ul>
      <div className="arrow" />
    </div>
  </li>
  <li className="transition">
    <div className="wrapper">
      <span className="transition">
        <h3 className="transition">Michael Gross<em>CEO Ceemi Marketing Agency</em></h3>
        <div className="image-container transition">
          <div className="creation">
            <div className="front">
              <div className="cont"> <i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1642849534487.jpg" alt="image" className="icon-circle transition" /></i> </div>
            </div>
            <div className="back">
              <div className="cont"><i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1642849534487.jpg" alt="image" /></i> </div>
            </div>
          </div>
        </div>
      </span>
      <ul className="social transition">
        <div className="social-buttons lead-1">
          <a className="social-facebook" href="https://www.facebook.com/michael.gross.9212301" target="_blank"><i className="fab fa-facebook" /></a>
          <a className="social-twitter" href="https://twitter.com/ceemiceo" target="_blank"><i className="fab fa-twitter" /></a><a className="social-instagram" href="https://www.instagram.com/nft_crypto_ceo/" target="_blank"><i className="fab fa-instagram" /></a>
          <a className="social-dribbble" href="https://www.linkedin.com/in/michael-gross-4511872b/" target="_blank"><i className="fab fa-linkedin" /></a>
          </div>
      </ul>
      <div className="arrow" />
    </div>
  </li>
  <li className="transition">
    <div className="wrapper">
      <span className="transition">
        <h3 className="transition">Redouane Belhadi<em>Lead Artist</em></h3>
        <div className="image-container transition">
          <div className="creation">
            <div className="front">
              <div className="cont"> <i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1641158681922.jpg" alt="image" className="icon-circle transition" /></i> </div>
            </div>
            <div className="back">
              <div className="cont"><i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1641158681922.jpg" alt="image" /></i> </div>
            </div>
          </div>
        </div>
      </span>
      <ul className="social transition">
        <div className="social-buttons lead-1">
          <a className="social-instagram" href="https://www.instagram.com/redouane_belhadi/" target="_blank"><i className="fab fa-instagram" /></a>
        <a className="social-instagram" href="https://music.amazon.com/artists/B09J17N2M6/redouane-belhadi" target="_blank"><img src="assets/img/apple-music.png" width="20px" style={{"margin-top":"-6px"}} /></a>
        </div>
      </ul>
      <div className="arrow" />
    </div>
  </li>
  <li className="transition">
    <div className="wrapper">
      <span className="transition">
        <h3 className="transition">Elijah Shelley<em>Booty Coin General Manager</em></h3>
        <div className="image-container transition">
          <div className="creation">
            <div className="front">
              <div className="cont"> <i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1642852279491.jpg" alt="image" className="icon-circle transition" /></i> </div>
            </div>
            <div className="back">
              <div className="cont"><i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1642852279491.jpg" alt="image" /></i> </div>
            </div>
          </div>
        </div>
      </span>
      <ul className="social transition">
        <div className="social-buttons lead-1">
          <a className="social-facebook" href="https://www.facebook.com/elijah.shelley.1" target="_blank"><i className="fab fa-facebook" /></a>
          <a className="social-instagram" href="https://www.instagram.com/shelleyelijah/" target="_blank"><i className="fab fa-instagram" /></a>
          <a className="social-dribbble" href="https://www.linkedin.com/search/results/all/?keywords=elijah%20shelley&origin=RICH_QUERY_TYPEAHEAD_HISTORY&position=0&searchId=af04c786-d68e-4258-9dad-60d6d6811e1c&sid=IXr" target="_blank"><i className="fab fa-linkedin" /></a>
          </div>
      </ul>
      <div className="arrow" />
    </div>
  </li>
  <li className="transition">
    <div className="wrapper">
      <span className="transition">
        <h3 className="transition">Redouane Belhadi<em>Lead Artist</em></h3>
        <div className="image-container transition">
          <div className="creation">
            <div className="front">
              <div className="cont"> <i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1641158681922.jpg" alt="image" className="icon-circle transition" /></i> </div>
            </div>
            <div className="back">
              <div className="cont"><i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1641158681922.jpg" alt="image" /></i> </div>
            </div>
          </div>
        </div>
      </span>
      <ul className="social transition">
        <div className="social-buttons lead-1"><a className="social-instagram" href="https://www.instagram.com/redouane_belhadi/" target="_blank"><i className="fab fa-instagram" /></a><a className="social-instagram" href="https://music.amazon.com/artists/B09J17N2M6/redouane-belhadi" target="_blank"><img src="assets/img/apple-music.png" width="20px" style={{"margin-top":"-6px"}} /></a></div>
      </ul>
      <div className="arrow" />
    </div>
  </li>
  <li className="transition">
    <div className="wrapper">
      <span className="transition">
        <h3 className="transition">Elijah Shelley<em>Booty Coin General Manager</em></h3>
        <div className="image-container transition">
          <div className="creation">
            <div className="front">
              <div className="cont"> <i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1642852279491.jpg" alt="image" className="icon-circle transition" /></i> </div>
            </div>
            <div className="back">
              <div className="cont"><i className="details"><img src="https://barBooty Coin Mintclub.com:6024/api/uploads/image-1642852279491.jpg" alt="image" /></i> </div>
            </div>
          </div>
        </div>
      </span>
      <ul className="social transition">
        <div className="social-buttons lead-1"><a className="social-facebook" href="https://www.facebook.com/elijah.shelley.1" target="_blank"><i className="fab fa-facebook" /></a><a className="social-instagram" href="https://www.instagram.com/shelleyelijah/" target="_blank"><i className="fab fa-instagram" /></a><a className="social-dribbble" href="https://www.linkedin.com/search/results/all/?keywords=elijah%20shelley&origin=RICH_QUERY_TYPEAHEAD_HISTORY&position=0&searchId=af04c786-d68e-4258-9dad-60d6d6811e1c&sid=IXr" target="_blank"><i className="fab fa-linkedin" /></a></div>
      </ul>
      <div className="arrow" />
    </div>
  </li>
</ul> */}
                {/* <ul className="eight">
                  {content7.map(item => {
                    return (<li className="transition">
                      <div className="wrapper">
                        <span className="transition">
                          <h3 className="transition">
                            {item.member}<em>{item.designation}</em></h3>
                          <div className="image-container transition">
                            <div className="creation">
                              <div className="front">
                                <div className="cont"> <i className="details">
                                  {item.member_pic === null || item.member_pic === '' || item.member_pic === undefined
                                    ?
                                    <img src='assets/img/avatar/1.jpg' className="icon-circle transition" />
                                    :
                                    <img src={`${config.imageUrl}${item.member_pic}`} alt="image" className="icon-circle transition" />}
                                </i> </div>
                              </div>
                              <div className="back">
                                <div className="cont">


                                  <i className="details">
                                    {item.member_pic === null || item.member_pic === '' || item.member_pic === undefined
                                      ?
                                      <img src='assets/img/avatar/1.jpg' />
                                      :
                                      <img src={`${config.imageUrl}${item.member_pic}`} alt="image" />}
                                  </i> </div>
                              </div>
                            </div>
                          </div>
                        </span>
                        <ul className="social transition">
                          <div className="social-buttons lead-1">
                            {item.facebook ?
                              <a className="social-facebook" href={item.facebook} target="_blank"><i className="fab fa-facebook" /></a>
                              :
                              ''
                            }
                            {item.twitter ?
                              <a className="social-twitter" href={item.twitter} target="_blank"><i className="fab fa-twitter" /></a>
                              : ''}
                            {item.instagram ?
                              <a className="social-instagram" href={item.instagram} target="_blank"><i className="fab fa-instagram" /></a>
                              : ''}

                            {item.linkedin ?
                              <a className="social-dribbble" href={item.linkedin} target="_blank"><i className="fab fa-linkedin" /></a>
                              : ''}

                            {item.spotify ?
                              <a className="social-instagram" href={item.spotify} target="_blank"><img src="assets/img/spotify.png" width="20px" style={{ marginTop: '-6px' }} /></a> : ''}

                            {item.music ?
                              <a className="social-instagram" href={item.music} target="_blank"><img src="assets/img/apple-music.png" width="20px" style={{ marginTop: '-6px' }} /></a> : ''}

                            {item.youtube ?
                              <a className="social-dribbble" target="_blank" href={item.youtube}><i className="fab fa-youtube"></i></a> : ''}
                          </div>
                        
                        </ul>
                        <div className="arrow" />
                      </div>
                    </li>)


                  })}


                </ul> */}

              </div>

            </div>
            {/* <div className="row">
              <div className="col-md-4 mb-7 mb-md-0">
                <a href="team.html">
                </a><article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5"><a href="team.html">
                  <div className="position-relative overflow-hidden br-n   article-image ar-1_1 w-70 mx-auto  border border-secondary mb-3" style={{ backgroundImage: 'url(assets/img/avatar/Jeremy_Dunn.jpg)', backgroundSize: '100% 100%' }} />
                </a><figure><a href="team.html">
                </a><figcaption><a href="team.html">
                </a><h5 className="text-light mt-1 mb-0"><a href="team.html" /><a href="#" className="text-light">Corey Robinson</a></h5>
                      <div className="social-buttons lead-1">
                          <a className="social-facebook" target="_blank" href="https://www.facebook.com/jeremiah.m.dunn/"><i className="fab fa-facebook" /></a>
                          <a className="social-twitter" target="_blank" href="https://twitter.com/jeremiah_dunn"><i className="fab fa-twitter" /></a>
                          <a className="social-instagram" target="_blank" href="https://www.instagram.com/jeremiahdunn/"><i className="fab fa-instagram" /></a>
                          <a className="social-dribbble" target="_blank" href="  https://www.linkedin.com/in/jeremiahdunn/"><i className="fab fa-linkedin" /></a>
                      </div>
                    
                    </figcaption>
                  </figure>
                </article>
              </div>
              <div className="col-md-4 mb-7 mb-md-0">
                <a href="team.html">
                </a><article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5"><a href="team.html">
                  <div className="position-relative overflow-hidden br-n   article-image ar-1_1 w-70 mx-auto  border border-secondary mb-3" style={{ backgroundImage: 'url(assets/img/oschino_kids.jpg)', backgroundSize: '100% 100%' }} />
                </a><figure><a href="team.html">
                </a><figcaption><a href="team.html">
                </a><h5 className="text-light mt-1 mb-0"><a href="team.html" /><a href="#" className="text-light">Oschino Vasquez</a></h5>
                      <div className="social-buttons lead-1">

                        <a className="social-instagram" target="_blank" href=" https://www.instagram.com/oschinovasquez1/"><i className="fab fa-instagram" /></a>
                        <a className="social-instagram" target="_blank" href=" https://open.spotify.com/artist/59h9wM4IPZZKUcMGiMaCJn?si=IpIPkYg4T16Pav0WrrEXAg"><img src="assets/img/spotify.png" width="20px" style={{"margin-top":"-6px"}} /></a>
                        <a className="social-instagram" target="_blank" href=" https://music.apple.com/us/artist/oschino/2091128"><img src="assets/img/apple-music.png" width="20px" style={{"margin-top":"-6px"}} /></a>
                        <a className="social-dribbble" target="_blank" href="https://www.youtube.com/c/OschinoVasquez"><i className="fab fa-youtube" /></a>

                      </div>
               
                    </figcaption>
                  </figure>
                </article>
              </div>
              <div className="col-md-4">
                <a href="team.html">
                </a><article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5"><a href="team.html">
                  <div className="position-relative overflow-hidden br-n  article-image ar-1_1 w-70 mx-auto  border border-secondary mb-3" style={{ backgroundImage: 'url(assets/img/avatar/team3.jpg)', backgroundSize: '100% 100%' }} />
                </a><figure><a href="team.html">
                </a><figcaption><a href="team.html">
                </a><h5 className="text-light mt-1 mb-0"><a href="team.html" /><a href="#" className="text-light">Redouane Belhadi</a></h5>
                      <div className="social-buttons lead-1">
                      <a className="social-instagram" target="_blank" href="https://music.amazon.com/artists/B09J17N2M6/redouane-belhadi"><img src="assets/img/apple-music.png" width="20px" style={{"margin-top":"-6px"}} /></a>
                      <a className="social-instagram" target="_blank" href="https://www.instagram.com/redouane_belhadi/"><i className="fab fa-instagram" /></a>
                      
                      </div>
                      
                    </figcaption>
                  </figure>
                </article>
              </div>
            </div> */}
          </div>
        </section>
        {/* /.End Content Area */}
        {/* Start Content Area */}

        <section id="faq" className="content-section team-section latest-articles position-relative text-center text-light parallax-window" data-parallax="scroll" data-image-src="#" >
          <div className="container position-relative">
            <header className="section-header">
              <h2 className="text-light ">Frequently Ask Questions?</h2>
              <hr className="w-10 border-success border-top-2 o-90" />
            </header>
            <div className="">
              <div className="">
                {/* ********* <3 ********* EIGHT ********* <3 ********* */}
                <Accordion>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        What is Booty Coin?
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        Booty Coin NFT is a recurring autonomous blockchain lottery where ownership of a coin is its own entry to every drawing.
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        How often are the drawings?
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        There are drawings once every week, month, and year with cumulative pools for each.
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Is every Booty Coin NFT = to one entry?
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        The rarity of a coin affects how many entries it gets to each drawing. The rarity is correlated to the coin's multiplier (located on its backside). Example x1=1 entry; 100x-100 entries; 420x=420 entries.
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        How is a drawing funded?
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        Everytime a BCNFT is sold or resold 4% is divided into each of the three drawings cumulative pools. 2% weekly, 1% monthly and 1% yearly.
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>
                  <AccordionItem>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Can you win more than once with an individual BCNFT?
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <p>
                        Yes. There is no limit to the number of times one BCNFT can win.
                      </p>
                    </AccordionItemPanel>
                  </AccordionItem>



                </Accordion>
                {/* <Accordion>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                               WHAT AREBooty Coin MintS?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          TheBooty Coin Mint project comprises a collection of 10,000 unique pieces of digital art that combine authentic and rare traits with unparalleled utility forBooty Coin Mint owners. We will have 11 hand painted one-of-ones from the legend himself Oschino Vasquez Wait, the insanity doesn't stop there! We will have 100 one-of-ones that grants the token holder a personalized beer mug kept in the bar with free beer for life! We want to build a community of people that love to socialize and talk crypto, have fun, party, and make money along the way!
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                              WHAT IS THE MINTING DATE?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Our release will be in March. The exact date will be announced on Discord and Twitter.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                          WHERE CAN I BUY ABooty Coin Mint?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          The mint event will be accessible through our official website only. During this event, you will be able to mintBooty Coin Mint’s at a cost of 0.099 ETH. After this initial minting process, you can showcase and trade yourBooty Coin Mint’s on OpenSea and other marketplaces.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                          WHAT IS OUR DIFFERENTIATING FACTOR?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          While we are working with legendary artists to create authentic and unique pieces of art, we will not want to stop there. Instead, we wanted to double down on what we believe makes NFTs truly special: real world utility! Check out our roadmap to see the insanity for yourself.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                          WHO IS ON THE TEAM?
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Headlined by experienced business and NFT enthusiast and up and coming Artist Redouane Belhadi. Our team also encompasses local marquee Booty Coin Mint advisors who will also join the real life team in the Booty Coin management.
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                    


                </Accordion> */}
                {/* <Accordion>
                  {content8.map(item => {
                    return (
                      <AccordionItem>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            {item.question}
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                            {item.answer}
                          </p>
                        </AccordionItemPanel>
                      </AccordionItem>
                    )

                  })}
                </Accordion> */}

              </div>

            </div>
            {/* <div className="row">
              <div className="col-md-4 mb-7 mb-md-0">
                <a href="team.html">
                </a><article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5"><a href="team.html">
                  <div className="position-relative overflow-hidden br-n   article-image ar-1_1 w-70 mx-auto  border border-secondary mb-3" style={{ backgroundImage: 'url(assets/img/avatar/Jeremy_Dunn.jpg)', backgroundSize: '100% 100%' }} />
                </a><figure><a href="team.html">
                </a><figcaption><a href="team.html">
                </a><h5 className="text-light mt-1 mb-0"><a href="team.html" /><a href="#" className="text-light">Corey Robinson</a></h5>
                      <div className="social-buttons lead-1">
                          <a className="social-facebook" target="_blank" href="https://www.facebook.com/jeremiah.m.dunn/"><i className="fab fa-facebook" /></a>
                          <a className="social-twitter" target="_blank" href="https://twitter.com/jeremiah_dunn"><i className="fab fa-twitter" /></a>
                          <a className="social-instagram" target="_blank" href="https://www.instagram.com/jeremiahdunn/"><i className="fab fa-instagram" /></a>
                          <a className="social-dribbble" target="_blank" href="  https://www.linkedin.com/in/jeremiahdunn/"><i className="fab fa-linkedin" /></a>
                      </div>
                    
                    </figcaption>
                  </figure>
                </article>
              </div>
              <div className="col-md-4 mb-7 mb-md-0">
                <a href="team.html">
                </a><article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5"><a href="team.html">
                  <div className="position-relative overflow-hidden br-n   article-image ar-1_1 w-70 mx-auto  border border-secondary mb-3" style={{ backgroundImage: 'url(assets/img/oschino_kids.jpg)', backgroundSize: '100% 100%' }} />
                </a><figure><a href="team.html">
                </a><figcaption><a href="team.html">
                </a><h5 className="text-light mt-1 mb-0"><a href="team.html" /><a href="#" className="text-light">Oschino Vasquez</a></h5>
                      <div className="social-buttons lead-1">

                        <a className="social-instagram" target="_blank" href=" https://www.instagram.com/oschinovasquez1/"><i className="fab fa-instagram" /></a>
                        <a className="social-instagram" target="_blank" href=" https://open.spotify.com/artist/59h9wM4IPZZKUcMGiMaCJn?si=IpIPkYg4T16Pav0WrrEXAg"><img src="assets/img/spotify.png" width="20px" style={{"margin-top":"-6px"}} /></a>
                        <a className="social-instagram" target="_blank" href=" https://music.apple.com/us/artist/oschino/2091128"><img src="assets/img/apple-music.png" width="20px" style={{"margin-top":"-6px"}} /></a>
                        <a className="social-dribbble" target="_blank" href="https://www.youtube.com/c/OschinoVasquez"><i className="fab fa-youtube" /></a>

                      </div>
               
                    </figcaption>
                  </figure>
                </article>
              </div>
              <div className="col-md-4">
                <a href="team.html">
                </a><article className="card article-post bg-dark_A-40 border border-secondary py-6 px-5"><a href="team.html">
                  <div className="position-relative overflow-hidden br-n  article-image ar-1_1 w-70 mx-auto  border border-secondary mb-3" style={{ backgroundImage: 'url(assets/img/avatar/team3.jpg)', backgroundSize: '100% 100%' }} />
                </a><figure><a href="team.html">
                </a><figcaption><a href="team.html">
                </a><h5 className="text-light mt-1 mb-0"><a href="team.html" /><a href="#" className="text-light">Redouane Belhadi</a></h5>
                      <div className="social-buttons lead-1">
                      <a className="social-instagram" target="_blank" href="https://music.amazon.com/artists/B09J17N2M6/redouane-belhadi"><img src="assets/img/apple-music.png" width="20px" style={{"margin-top":"-6px"}} /></a>
                      <a className="social-instagram" target="_blank" href="https://www.instagram.com/redouane_belhadi/"><i className="fab fa-instagram" /></a>
                      
                      </div>
                      
                    </figcaption>
                  </figure>
                </article>
              </div>
            </div> */}
          </div>
        </section>
        {/* /.End Content Area */}
      </main>
      <Footer />
    </>
  );


}

export default Home;